import React from "react";

import {
    CommentCreateForm,
    CommentFormData,
} from "@/mk2/apps/forum/components/CommentCreateEditForm";
import { PostEntity } from "@/mk2/apps/forum/schemas";
import { UserEntity } from "@/mk2/schemas";
import { BLOCKED_FROM_THIS_DISCUSSION_MESSAGE } from "@/mk/autogenerated/translations/ForumCommentAdd.85a94c2938b8a6ba8504c9684d7aab1a";
import { isAuthenticated } from "@/mk/bazaar/common/userUtils";

import styles from "./ForumCommentAdd.mscss";

interface OwnProps {
    anonymousMode: boolean;
    canAdd: boolean;
    canShowForm: boolean;
    hasBlueToolbar?: boolean;
    initialValues: CommentFormData;
    currentValues: CommentFormData;
    isAskAnExpert: boolean;
    isBlogsComment: boolean;
    isContest: boolean;
    isEdit: boolean;
    isGroupsComment: boolean;
    isIOS: boolean;
    isMobile: boolean;
    post: PostEntity;
    requestUser: UserEntity;
    requestUserPermissions: string[];
    showContestAnswers: boolean;
    textareaRef?: (r: HTMLTextAreaElement) => void;
    onSave(values: CommentFormData);
    onSaveUnauthenticated(values: CommentFormData);
}

const ForumCommentAdd: React.FunctionComponent<OwnProps> = ({
    anonymousMode,
    canAdd,
    canShowForm,
    currentValues,
    hasBlueToolbar,
    initialValues,
    isAskAnExpert,
    isBlogsComment,
    isContest,
    isEdit,
    isGroupsComment,
    isIOS,
    isMobile,
    onSave,
    onSaveUnauthenticated,
    post,
    requestUser,
    requestUserPermissions,
    showContestAnswers,
    textareaRef,
}) => {
    const showUnauthenticatedForm =
        canShowForm && !isAuthenticated(requestUser) && (!isContest || !showContestAnswers);

    if (canAdd) {
        return (
            <CommentCreateForm
                anonymousMode={anonymousMode}
                hasBlueToolbar={hasBlueToolbar}
                isEdit={isEdit}
                isMobile={isMobile}
                isIOS={isIOS}
                textareaRef={textareaRef}
                isContest={isContest}
                isBlogsComment={isBlogsComment}
                isGroupsComment={isGroupsComment}
                requestUserPermissions={requestUserPermissions}
                initialValues={initialValues}
                currentValues={currentValues}
                onSave={onSave}
            />
        );
    } else if (showUnauthenticatedForm) {
        return (
            <CommentCreateForm
                anonymousMode={anonymousMode}
                hasBlueToolbar={hasBlueToolbar}
                isEdit={isEdit}
                isMobile={isMobile}
                isIOS={isIOS}
                textareaRef={textareaRef}
                isContest={isContest}
                isBlogsComment={isBlogsComment}
                isGroupsComment={isGroupsComment}
                isUnauthenticatedUser
                requestUserPermissions={requestUserPermissions}
                initialValues={initialValues}
                currentValues={currentValues}
                onSave={onSaveUnauthenticated}
            />
        );
    } else if (post?.blockedFromThread) {
        return (
            <div className={styles.ForumCommentAdd__blockedNotice}>
                {BLOCKED_FROM_THIS_DISCUSSION_MESSAGE}
            </div>
        );
    } else {
        return null;
    }
};

ForumCommentAdd.displayName = "ForumCommentAdd";

export default React.memo<OwnProps>(ForumCommentAdd);
